// TASK-974: pair the screen-hold upload. No frontend behavior change.
// Preview pairing: frontend-git-{branch} ↔ backend-git-{branch} (see BE envConfig.ts TASK-565).
// TASK-789: Demo / Operations switch for the company line shop — FE.
// TASK-849: Active Plans — advertise the Voice number or forward the existing number to it.
// TASK-851: public contact info@ + AI phone; sales one-pager number — FE.
// TASK-917: Visit Site website-or-Maps place_id fallback — FE.
// TASK-896 / TASK-900: map + visited listings Voice DID (AI phone) — FE/BE.
// TASK-916: hide Voice Pause UI until aggregate Pause (TASK-915) — FE.
// TASK-912: pairing for Direct multi-select customer availability chips — FE.
// TASK-905: pairing for Voice entitlements PATCH (calendar/recording) — BE.
// TASK-909 / TASK-910: pairing for Voice partner GET call-artifacts (transcript + signed recording URL) — BE.
// TASK-893: pairing for Voice call transcript and recording save — BE.
// TASK-892: pairing for Voice by-phone first_name, last_name, and email — BE.
// TASK-888: pairing for Voice Direct preferred chip end_time (+1h) — BE.
// TASK-885: pairing for Voice shop-timezone availability + Direct preferred time (BE).
// TASK-882 / TASK-883: Voice Direct intake + owner-invite (no calendar) — BE.
// TASK-845: pairing for Voice customer/garage/service lookup APIs + book gate (BE).
// TASK-582 Layer 0: paired branch for CI/previews; voice integration ships on backend (autoshops-backend#68).
// TASK-536: Google Calendar live adapter + connect panel (paired with backend task-522).
// TASK-0000: Preview environment infrastructure verified
// TASK-341: BE-only (backend error log) — FE comment triggers paired preview deploy for CI.
// TASK-758: paired preview deploy for Sprint 12 test
const getApiBase = () => {
  // 1. Explicit env var (set in Vercel for test/preprod/production, empty for feature branches)
  const apiBase = process.env.REACT_APP_API_BASE;
  if (apiBase) {
    console.log("✅ Using API Base (explicit):", apiBase);
    return apiBase;
  }

  // 2. Stable branch URL (injected by prebuild script from VERCEL_BRANCH_URL)
  const branchUrl = process.env.REACT_APP_VERCEL_BRANCH_URL;
  if (branchUrl) {
    const backendUrl = "https://" + branchUrl.replace("frontend-", "backend-");
    console.log("✅ Using API Base (derived from Branch URL):", backendUrl);
    return backendUrl;
  }

  // 3. Deployment-specific hash URL (fallback if branch URL not available)
  const vercelUrl = process.env.REACT_APP_VERCEL_URL;
  if (vercelUrl) {
    const backendUrl = "https://" + vercelUrl.replace("frontend-", "backend-");
    console.log("✅ Using API Base (derived from Vercel URL):", backendUrl);
    return backendUrl;
  }

  // 4. Local development fallback
  console.log("✅ Using API Base (local fallback): http://localhost:3001");
  return "http://localhost:3001";
};

export default getApiBase;
